/**************************************************
 * Nombre:       Formulario_Totales.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import caja from '../../Recursos/foto_caja.png'

const Formulario_Totales = ({...props}) => {
    const [rutas, setRutas] = useState([]);
    const [envio, setEnvio] = useState([]);


    const obtenerValorTotal = (prods) => {


        let val = 0

        for (let i = 0; i < prods.length; i++) {
            val += prods[i].valor * prods[i].cantidad
        }
        return val

    }

    useEffect(() => {


        let provin = props.props.getValues('provincia')
        let w = [where('nombre', '==', provin)]
        obtenerColWheres({col: "rutas", wheres: w}).then((dox) => {
            if (dox.res && dox.data[0]) {
                setEnvio(dox.data[0])
                props.props.setValue('valorEnvio', dox.data[0].valor)
            }
        })

    }, [props.props.getValues('provincia')])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Ya casi tu pedido hecho</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <img src={caja} width={'70%'} height={'auto'} />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 0}}>
                    <Typography sx={{fontSize: 20}}>Valor Compra:
                        <span style={{marginLeft: 10, fontWeight: 'bold'}}>
                        {formatoMoneda(obtenerValorTotal(props.props.getValues('productos')))}
                    </span>
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: -2}}>
                    <Typography sx={{fontSize: 20}}>Valor Envio:
                        <span style={{marginLeft: 10, fontWeight: 'bold'}}>
                        {formatoMoneda(envio.valor)}
                    </span>
                    </Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Totales